export default __webpack_public_path__ + "static/media/bjsh-code-base.2661dd44.jpg";